import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Swal from 'sweetalert2';

const GoogleCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(true);
    const hasProcessed = useRef(false);

    useEffect(() => {
        const processCallback = async () => {
            if (hasProcessed.current) return;
            hasProcessed.current = true;

            const searchParams = new URLSearchParams(location.search);
            const code = searchParams.get('code');
            const error = searchParams.get('error');

            console.log("GoogleCallback: Procesando callback...", { hasCode: !!code, error });

            if (error) {
                console.error("GoogleAuth Error:", error);
                Swal.fire('Error', `Google Auth Error: ${error}`, 'error');
                navigate('/app/configuracion');
                return;
            }

            if (!code) {
                console.warn("GoogleCallback: No se recibió código de autorización");
                Swal.fire('Error', 'No se recibió código de autorización', 'error');
                navigate('/app/configuracion');
                return;
            }

            try {
                console.log("GoogleCallback: Enviando código al backend...");
                // Enviar el código al backend (ya autenticado con el token del usuario)
                const response = await api.post('/empresa/callback_gmail/', { code });
                console.log("GoogleCallback: Respuesta exitosa del backend", response.data);

                await Swal.fire({
                    icon: 'success',
                    title: '¡Vinculación Exitosa!',
                    text: 'Tu cuenta de Gmail ha sido vinculada correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            } catch (err) {
                console.error("Error vinculando Gmail:", err);
                const detail = err.response?.data?.detail || "Falló la vinculación con Google. Intenta nuevamente.";
                Swal.fire('Error', detail, 'error');
            } finally {
                setProcessing(false);
                navigate('/app/configuracion');
            }
        };

        processCallback();
    }, [location, navigate]);

    if (processing) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Procesando...</span>
                    </div>
                    <h4 className="mt-3">Vinculando con Google...</h4>
                    <p className="text-muted">Por favor espera un momento.</p>
                </div>
            </div>
        );
    }

    return null;
};

export default GoogleCallback;
